import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import '../styles/Kurumsal.css';
import { FaWhatsapp } from "react-icons/fa";

const Kurumsal = () => {
  return (
    <div className="kurumsal">
      <Header />
      
      <main className="main-content">
        {/* Hero Section */}
        <section className="page-hero">
          <div className="hero-content">
            <h1>Kurumsal</h1>
            <p>Balcı Mobilya'nın hikayesi ve değerleri</p>
          </div>
        </section>

        {/* About Section */}
        <section className="about-section">
          <div className="container">
            <div className="about-content">
              <div className="about-text">
                <h2>Hakkımızda</h2>
                <p>Balcı Mobilya olarak, 35 yılı aşkın deneyimimizle mobilya ve beyaz eşya sektöründe kaliteli hizmet sunmaktayız. Müşteri memnuniyetini ön planda tutarak, modern tasarımlar ve uygun fiyatlarla evinizi güzelleştiriyoruz.</p>
                <p>Deneyimli ekibimiz ve geniş ürün yelpazemiz ile sizlere en uygun çözümleri sunmaya devam ediyoruz. Kaliteli malzeme, uzman işçilik ve müşteri odaklı yaklaşımımız ile sektörde öncü konumda yer alıyoruz.</p>
              </div>
              <div className="about-image">
                <div className="image-placeholder">
                  <img src="../files/balci-mobilya-dis.jpeg" alt="Balcı Mobilya" />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Vision Mission Section */}
        <section className="vision-mission">
          <div className="container">
            <div className="vm-grid">
              <div className="vm-card">
                <div className="vm-icon">🎯</div>
                <h3>Vizyonumuz</h3>
                <p>Mobilya ve beyaz eşya sektöründe güvenilir, kaliteli ve yenilikçi çözümler sunan lider firma olmak. Müşterilerimizin yaşam alanlarını güzelleştirerek, onların hayat kalitesini artırmak.</p>
              </div>
              <div className="vm-card">
                <div className="vm-icon">🌟</div>
                <h3>Misyonumuz</h3>
                <p>Müşteri memnuniyetini ön planda tutarak, kaliteli ürünler ve profesyonel hizmet anlayışı ile müşterilerimizin ihtiyaçlarını en iyi şekilde karşılamak. Sürdürülebilir büyüme ile sektörde öncü konumda yer almak.</p>
              </div>
            </div>
          </div>
        </section>

        {/* Values Section */}
        <section className="values-section">
          <div className="container">
            <h2>Değerlerimiz</h2>
            <div className="values-grid">
              <div className="value-card">
                <div className="value-icon">🤝</div>
                <h3>Güvenilirlik</h3>
                <p>Müşterilerimizle güvene dayalı, uzun vadeli ilişkiler kuruyoruz.</p>
              </div>
              <div className="value-card">
                <div className="value-icon">✨</div>
                <h3>Kalite</h3>
                <p>En kaliteli malzemeler ve işçilik ile üretim yapıyoruz.</p>
              </div>
              <div className="value-card">
                <div className="value-icon">💡</div>
                <h3>Yenilikçilik</h3>
                <p>Sürekli gelişim ve yenilikçi çözümler sunuyoruz.</p>
              </div>
              <div className="value-card">
                <div className="value-icon">👥</div>
                <h3>Müşteri Odaklılık</h3>
                <p>Müşteri memnuniyetini her zaman ön planda tutuyoruz.</p>
              </div>
              <div className="value-card">
                <div className="value-icon">🌱</div>
                <h3>Sürdürülebilirlik</h3>
                <p>Çevre dostu üretim ve sürdürülebilir iş modelleri benimsiyoruz.</p>
              </div>
              <div className="value-card">
                <div className="value-icon">🏆</div>
                <h3>Mükemmellik</h3>
                <p>Her işimizde mükemmelliği hedefliyoruz.</p>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default Kurumsal; 